import { useEffect, useState } from "react";
import { API_URL } from "../../shared/constant";
import { toast } from "react-toastify";
import { Watch } from "react-loader-spinner";
import axios from "axios";


const AppSettings = () => {
  const [loading, setLoading] = useState(false);
  const [formValue, setFormValue] = useState({
    version: "",
    app_url: "",
    facebook: "",
    linkedin: "",
    website: "",
    instagram: "",
    i_phone_url: "",
    address: "",
    location: "",
    email: "",
    company: ""
  });

  const saveItem = () => {
    setLoading(true);
      axios
        .post(API_URL.SETTING_SAVE, formValue)
        .then((res) => {
          setLoading(false);
          if (res.data.status === 1) {
            toast.success("Saved", {
                autoClose: 3000,
                
            });
          } else {
            toast.error(res.data.data, { autoClose: 3000 });
          }
        })
        .catch(() => {
          setLoading(false);
        });
  };

  const onEdit = () => {
    axios.post(API_URL.SETTING_SHOW, {}).then((res) => {
      if (res.data.status === 1) {
        setFormValue({
            version: (res.data.data.version) ? res.data.data.version: "",
            app_url: (res.data.data.app_url) ? res.data.data.app_url: "",
            facebook: (res.data.data.facebook) ? res.data.data.facebook: "",
            linkedin: (res.data.data.linkedin) ? res.data.data.linkedin: "",
            website: (res.data.data.website) ? res.data.data.website: "",
            instagram: (res.data.data.instagram) ? res.data.data.instagram: "",
            i_phone_url: (res.data.data.i_phone_url) ? res.data.data.i_phone_url: "",
            address: (res.data.data.address) ? res.data.data.address: "",
            location: (res.data.data.location) ? res.data.data.location: "",
            email: (res.data.data.email) ? res.data.data.email: "",
            company: (res.data.data.company) ? res.data.data.company: ""
        });
      }
    });
  };

  const updateForm = (name, evt) => {
    setFormValue({...formValue, [name]: evt.target.value});
  }

  useEffect(() => {
    onEdit();
  }, []);

  return (
    <>
      <div className="row">
        <div className="col-6">
          <h1>App Settings</h1>
        </div>
        <div className="col-12">
          <div className="card">
            <div className="card-body">
              <form onSubmit={(event) => event.preventDefault()}>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="form-label">Company</label>
                      <input type="text" name="company" value={formValue.company} className="form-control" onChange={(event) => {updateForm('company', event)}}/>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="form-label">Address</label>
                      <input type="text" name="address" value={formValue.address} className="form-control" onChange={(event) => {updateForm('address', event)}}/>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="form-label">Location</label>
                      <input type="text" name="location" value={formValue.location} className="form-control" onChange={(event) => {updateForm('location', event)}}/>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="form-label">Email</label>
                      <input type="text" name="email" value={formValue.email} className="form-control" onChange={(event) => {updateForm('email', event)}}/>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="form-label">Website</label>
                      <input type="text" name="website" value={formValue.website} className="form-control" onChange={(event) => {updateForm('website', event)}}/>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="form-label">Version</label>
                      <input type="text" name="version" value={formValue.version} className="form-control" onChange={(event) => {updateForm('version', event)}}/>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="form-label">Instagram</label>
                      <input type="text" name="instagram" value={formValue.instagram} className="form-control" onChange={(event) => {updateForm('instagram', event)}}/>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="form-label">Linkedin</label>
                      <input type="text" name="linkedin" value={formValue.linkedin} className="form-control" onChange={(event) => {updateForm('linkedin', event)}}/>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="form-label">Facebook</label>
                      <input type="text" name="facebook" value={formValue.facebook} className="form-control" onChange={(event) => {updateForm('facebook', event)}}/>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="form-label">Play Store Url</label>
                      <input type="text" name="app_url" value={formValue.app_url} className="form-control" onChange={(event) => {updateForm('app_url', event)}}/>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="form-label">App Store Url</label>
                      <input type="text" name="i_phone_url" value={formValue.i_phone_url} className="form-control" onChange={(event) => {updateForm('i_phone_url', event)}}/>
                    </div>
                  </div>
                </div>
                <div className="col-lg-12 col-md-12 col-sm-12">
                  <div className="form-group text-right">
                    <button
                      type="submit"
                      onClick={saveItem}
                      disabled={loading}
                      className="btn btn-primary"
                    >
                      {loading ? (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Watch color={"white"} height={20} width={20} />
                        </div>
                      ) : (
                        "Save"
                      )}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AppSettings;